import React from 'react';

const NotificationMsgTemplateFormModal = React.lazy(() => import('../components/FormModal'));
const notificationMsgTemplateModalRegistry = {
    notification_notificationMsgTemplateId: NotificationMsgTemplateFormModal
};
export default notificationMsgTemplateModalRegistry;
